import { css } from '@emotion/react'

import { Step } from '@/service'

import { mediaColumns } from '@/styles/grid'

import StepItem from './Step'

interface Props {
  steps?: Step
}

function StepByStepList(props: Props) {
  const { steps } = props

  return (
    <ul css={styles.stepsList}>
      {steps?.content?.map((step, index) => (
        <StepItem key={index} step={step} index={index + 1} />
      ))}
    </ul>
  )
}

const styles = {
  stepsList: css`
    ${mediaColumns({ xs: [12, 0], md: [10, 1] })};
  `
}

export default StepByStepList
